'use client';
import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
const SidebarSimpleSvg = forwardRef(
  (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      ref={ref}
      {...props}
    >
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H80V200H40ZM216,200H96V56H216V200Z" />
    </svg>
  )
);
type ComponentProps = Omit<SvgIconProps, 'inheritViewbox' | 'component'>;
function Component(
  props: ComponentProps,
  ref: React.ForwardedRef<SVGSVGElement>
) {
  return (
    <SvgIcon
      data-testid="SidebarSimpleIcon"
      ref={ref}
      {...props}
      component={SidebarSimpleSvg}
      inheritViewBox
    />
  );
}
Component.displayName = 'SidebarSimpleIcon';
Component.muiName = SvgIcon.muiName;
export default React.memo(forwardRef(Component));
